import React, { useState, useEffect } from "react";
import Honour from "./FormSteps/Honour";
import Location from "./FormSteps/Location";
import Orientation from "./FormSteps/Orientation";
import Name from "./FormSteps/Name";
import options from "../../countries";
import axiosInstance from "../../services/axiosInstance"; // ✅ replaced axios import
import { APIS } from "../../services/config";
import BankDetails from "./FormSteps/BankDetails";

const FormStepsLogic = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [partners, setPartners] = useState([]);
  const [onboardingSteps, setOnboardingSteps] = useState({
    firstName: "",
    lastName: "",
  });
  const [value, setValue] = useState("");
  const [stateValue, setStateValue] = useState("");
  const [accountNumberValue, setAccountNumberValue] = useState("");
  const [bankNameValue, setBankNameValue] = useState("");
  const [localGovernmentValue, setLocalGovernmentValue] = useState("");
  const [referrerValue, setReferrerValue] = useState("");

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    window.location.reload();
  };

  const handleChange = (input) => (e) => {
    setOnboardingSteps({ ...onboardingSteps, [input]: e.target.value });
  };

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const deviceToken = userDetails?.webDeviceRegistrationToken;

  useEffect(() => {
    const {
      baseUrl,
      getPartners: { path },
    } = APIS;

    async function fetchPartners() {
      const request = await axiosInstance.get(baseUrl + path, {
        params: {
          limit: 1000, // retrieve all partners
          page: 1,
          sortBy: "name",
          sortOrder: "ASC",
        },
      });
      setPartners(request?.data?.data); // adjust based on actual response shape
    }
    fetchPartners();
  }, []);

  return (
    <>
      {activeStep === 0 && (
        <Name
          handleNext={handleNext}
          activeStep={activeStep}
          values={onboardingSteps}
          handleChange={handleChange}
        />
      )}
      {activeStep === 1 && (
        <BankDetails
          partners={partners}
          handleNext={handleNext}
          handleBack={handleBack}
          options={options}
          values={onboardingSteps}
          prompt="Country"
          statePrompt="State"
          localGovtPrompt="Local Government Area"
          referrerPrompt="Referrer"
          handleChange={handleChange}
          value={value}
          localGovernmentValue={localGovernmentValue}
          bankNameValue={bankNameValue}
          accountNumberValue={accountNumberValue}
          stateValue={stateValue}
          referrerValue={referrerValue}
          onChange={(val) => setValue(val)}
          onStateChange={(val) => setStateValue(val)}
          onBankValueChange={(val) => setBankNameValue(val)}
          onAccountNumberChange={(val) => setAccountNumberValue(val)}
          onReferrerChange={(val) => setReferrerValue(val)}
        />
      )}
      {activeStep === 2 && (
        <Location
          deviceToken={deviceToken}
          partners={partners}
          handleNext={handleNext}
          handleBack={handleBack}
          options={options}
          values={onboardingSteps}
          prompt="Country"
          statePrompt="State"
          localGovtPrompt="Local Government Area"
          referrerPrompt="Referrer"
          handleChange={handleChange}
          value={value}
          localGovernmentValue={localGovernmentValue}
          bankNameValue={bankNameValue}
          accountNumberValue={accountNumberValue}
          stateValue={stateValue}
          referrerValue={referrerValue}
          onChange={(val) => setValue(val)}
          onStateChange={(val) => setStateValue(val)}
          onLocalGovernmentChange={(val) => setLocalGovernmentValue(val)}
          onBankValueChange={(val) => setBankNameValue(val)}
          onAccountNumberChange={(val) => setAccountNumberValue(val)}
          onReferrerChange={(val) => setReferrerValue(val)}
        />
      )}
      {activeStep === 3 && (
        <Honour
          handleNext={handleNext}
          handleBack={handleBack}
          options={options}
          values={onboardingSteps}
          prompt="Country"
          statePrompt="State"
          localGovtPrompt="Local Government Area"
          referrerPrompt="Referrer"
          handleChange={handleChange}
          value={value}
          localGovernmentValue={localGovernmentValue}
          setBankNameValue={setBankNameValue}
          setAccountNumberValue={setAccountNumberValue}
          stateValue={stateValue}
          referrerValue={referrerValue}
          onChange={(val) => setValue(val)}
          onStateChange={(val) => setStateValue(val)}
          onLocalGovernmentChange={(val) => setLocalGovernmentValue(val)}
          onBankValueChange={(val) => setBankNameValue(val)}
          onAccountNumberChange={(val) => setAccountNumberValue(val)}
          onReferrerChange={(val) => setReferrerValue(val)}
        />
      )}
      {activeStep === 4 && <Orientation values={onboardingSteps} />}
    </>
  );
};

export default FormStepsLogic;
